



















import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {
    MeasurementTypeConfigurationRow
} from "@/components/Admin/Settings/Typeform/Helpers/MeasurementTypeConfigurationRow";
import {Api, Typeform_Form} from "@/core/services/MedicaPro/Api";
import { MeasurementTypeConfiguration } from '@/core/services/MedicaPro/models';

@Component({
    components: {

    }
})
export default class MeasurementTypeConfigurationView extends BaseComponent {

    // Bindings to parent
    @Prop() item!: MeasurementTypeConfigurationRow;
    @Prop() typeformForms!: Typeform_Form[];

    // Bindings to view
    public isReady = false;
    public name = '';
    public formId = '';

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    private renderView() {
        this.name = this.item.identifier;
        this.formId = this.item.configuration?.typeform_identifier ?? '';
        this.isReady = true;
    }

    public onFormIdChangEvent() {
        if (this.item.configuration) {
            this.item.configuration.typeform_identifier = this.formId;
            Api.measurementTypeConfigurations()
                .patchById(this.item.configuration.id!)
                .save(this.item.configuration);
        } else {
            this.item.configuration = new MeasurementTypeConfiguration();
            this.item.configuration.measurement_identifier = this.item.identifier;
            this.item.configuration.typeform_identifier = this.formId;
            Api.measurementTypeConfigurations()
                .post()
                .save(this.item.configuration, value => {
                    this.item.configuration?.populate(value);
                });
        }
    }

}
